import { render, staticRenderFns } from "./monitoringData.vue?vue&type=template&id=5fca6076&scoped=true"
import script from "./monitoringData.vue?vue&type=script&lang=js"
export * from "./monitoringData.vue?vue&type=script&lang=js"
import style0 from "./monitoringData.vue?vue&type=style&index=0&id=5fca6076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca6076",
  null
  
)

export default component.exports